// Lepoajastimen aikaleimalogiikka (osio 6.4).
// Aikaleimapohjainen: jäljellä oleva aika lasketaan aina kohdeajasta ja
// nykyhetkestä, joten se pysyy oikeana vaikka välilehti on taustalla tai näyttö
// sammuu välillä. Puhtaat funktiot → yksikkötestattavia (osio 11, testi #2).

/**
 * Jäljellä olevat sekunnit kohdeajasta. Negatiivinen tai mennyt → 0.
 */
export function computeRemainingSeconds(targetEndMs: number, nowMs: number): number {
  const remainingMs = targetEndMs - nowMs;
  if (remainingMs <= 0) return 0;
  return Math.ceil(remainingMs / 1000);
}

/** Muotoile sekunnit muotoon m:ss. */
export function formatTimer(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${m}:${sec.toString().padStart(2, '0')}`;
}
